module.exports = __webpack_public_path__ + "static/media/show.ca4c1d30.svg";